import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';

import JeepytaCheckbox from './components/JeepytaCheckbox';
import JeepytaHistoryCheckbox from './components/JeepytaHistoryCheckbox';
import Select from 'flarum/common/components/Select';
import SettingsPage from 'flarum/forum/components/SettingsPage';
// import JFile from '../common/Models/File';
import TagSelectionModal from 'flarum/tags/common/components/TagSelectionModal';
import addJeepytaPageButton from "./components/addJeepytaPageButton";
import MyMediaPage from "./components/JeepytaFilesPage";
import JeepytaFilesSettingsPage from "./components/JeepytaFilesSettingsPage";
import UserPage from 'flarum/components/UserPage';
app.initializers.add('vendor/jeepyta-options', () => {

  app.routes['profile.jeepyta'] = {
    path: '/u/:username/jeepyta',
    component: JeepytaFilesSettingsPage,
  };

  // app.routes['user.jeepyta'] = {
  //   path: '/u/:username/jeepyta',
  //   component: MyMediaPage,
  // };


  // extend(UserPage.prototype, 'navItems', function (items) {
  //   const user = this.user;
  //
  //   items.add(
  //     'new-tab',
  //     m(
  //       'a',
  //       {
  //         href: app.route('profile.jeepyta', { username: user.username() }),
  //         className: 'UserPage-nav-link',
  //         icon: 'fas fa-robot',
  //       },
  //       app.translator.trans('your-extension.forum.new_tab.nav_label')
  //     ),
  //     50 // Position in the menu
  //   );
  // });
  extend(SettingsPage.prototype, 'settingsItems', function(items) {

    // console.log('[vendor/jeepyta-options] Hello, forum!');
    items.add('jeepyta-checkbox',
      JeepytaCheckbox.component({user: this.user})
    );

    // items.add('jeepyta-history-checkbox',
    //   JeepytaHistoryCheckbox.component({user: this.user})
    // );
  });
  // Register the File model in the store - attempt to fix the overwriting of files in the store
  // app.store.models['jfiles'] = File;

  extend(SettingsPage.prototype, 'oninit', function () {
    // Add a flag to indicate loading state
    // this.isLoadingFiles = true;
    //
    // // Fetch files from the API
    // app.store.find('files').then((files) => {
    //   this.isLoadingFiles = false; // Set loading to false when done
    //   m.redraw(); // Trigger a redraw to update the UI
    // });
  });

  // extend(SettingsPage.prototype, 'settingsItems', function (items) {
  //   // Show a loading message if files are not yet loaded
  //   if (this.isLoadingFiles) {
  //     items.add(
  //       'loading-files',
  //       m('div', 'Loading files...')
  //     );
  //     return;
  //   }
  //
  //   // Fetch loaded files from the store
  //   // const sharedFiles = app.store.all('files');
  //   const sharedFiles = app.store.all('files').filter(file => file.data.attributes.tag !== null && file.data.attributes.shared == 1);
  //
  //   const tags = app.store.all('tags').map(tag => ({
  //     value: tag.id(),
  //     label: tag.name(),
  //   }));
  //
  //   const fileItems = sharedFiles.map(file => {
  //
  //     const associatedTags = file.data.attributes.associatedTags || []; // Get current tags
  //     const tagModels = associatedTags
  //       .map((tagId) => app.store.getById('tags', tagId))
  //       .filter(Boolean); // Convert tag IDs to models
  //
  //     return m('div', { className: 'Form-group' }, [
  //       m('label', `File: ${file.baseName()}`), // Display file name
  //
  //       // Render selected tags as badges
  //       m('div', { className: 'TagList' },
  //         tagModels.length > 0
  //           ? tagModels.map(tag =>
  //             m('span', { className: 'TagBadge' }, tag.name()) // Display each tag's name
  //           )
  //           : m('span', { className: 'NoTags' }, 'No tags selected') // Fallback if no tags are selected
  //       ),
  //
  //       // Button to open the "Choose Tags" modal
  //       m('button', {
  //         className: 'Button Button--primary',
  //         onclick: () => {
  //           // Open the tag selection modal
  //           app.modal.show(TagSelectionModal, {
  //             selectedTags: tagModels, // Pre-select the tags
  //             onsubmit: (selectedTags) => {
  //               const tagIds = selectedTags.map(tag => tag.id());
  //
  //               // Save the selected tags for this file
  //               app.request({
  //                 method: 'POST',
  //                 url: app.forum.attribute('apiUrl') + `/files/${file.id()}/tags`,
  //                 body: { tag_ids: tagIds }, // Replace 'tag_ids' with the correct parameter name
  //               })
  //                 .then(() => {
  //                   app.alerts.show({ type: 'success' }, 'Tags updated successfully');
  //                   file.pushAttributes({ associatedTags: tagIds }); // Update local model
  //                 })
  //                 .catch(() => {
  //                   app.alerts.show({ type: 'error' }, 'Failed to update tags');
  //                 });
  //             },
  //           });
  //         },
  //       }, 'Choose Tags'),
  //     ]);
  //   });
  //
  //
  //   const userGroups = this.user.groups();
  //   // Array of substrings to check in group names
  //   const allowedGroupNames = ['admin', 'instructor', 'ta'];
  //   // Check if any group name contains one of the allowed substrings
  //   const isInAllowedGroup = userGroups.some((group) => {
  //     const groupName = group.nameSingular().toLowerCase(); // Convert to lowercase for case-insensitive matching
  //     return allowedGroupNames.some((substring) => groupName.includes(substring));
  //   });
  //
  //   if (isInAllowedGroup) {
  //
  //     items.add(
  //       'jeepyta-section-heading',
  //       m('h3', { className: 'JeepytaSectionHeading' }, 'JeepyTA Files: settings') // Add heading
  //     );      // Add file-related UI to the settings page
  //     items.add(
  //       'jeepyta-file-tags',
  //       m('div', fileItems)
  //     );
  //   }
  // });

  addJeepytaPageButton();

});
